/* eslint-disable @typescript-eslint/no-unused-vars */
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import {
  sampleData,
  sampleExistingRules,
  sampleGenAiRules,
  sampleOverViewData,
  // sampleRawData,
  sampleRawData2,
  sampleRulePipelineStatus,
  sampleRules,
} from "./staticData"
import AxiosOperations from "../../services/AxiosOperations"
import { API_STATUS } from "../../util/StaticData"
import {
  IGenAiRules,
  IDataQualityState,
  IExistingRules,
  IRulePipelineStatus,
} from "../../util/interface"

const initialState: IDataQualityState = {
  activeReportModal: { status: false, qualityTypeId: null },
  dataQualityConfigModal: false,
  businessQualityConfigModal: false,
  navigationHistory: ["AI Enabled Quality"],
  refreshHit: 1,
  overViewData: sampleData,
  activeQualityTypeReport: null,
  rawData: {
    rawData: [],
    rawDataStatus: API_STATUS.IDLE,
    error: "",
  },
  selectedDataSet: "",
  dataQualityRules: {
    genAiRules: [],
    existingRules: [],
    dataqualityRulesStatus: API_STATUS.IDLE,
    GenAiRulesStatus: API_STATUS.IDLE,
    ImplementedRulesStatus: API_STATUS.IDLE,
    selectedAiGeneratedRules: [],
    selectedExistingRules: [],
    dataset: "",
    error: "",
  },
  businessQualityRules: {
    genAiRules: [],
    existingRules: [],
    dataqualityRulesStatus: API_STATUS.IDLE,
    selectedAiGeneratedRules: [],
    selectedExistingRules: [],
    dataset: "",
    error: "",
  },
  aiRulesModalData: {
    configuration: {
      dataset: "",
      description: "",
      columnsToApply: "",
    },
  },
  manualRulesModalData: {
    dataset: "",
    description: "",
    columnsToApply: "",
  },
  runQCCheck: API_STATUS.IDLE,
  runId: null,
  rulePipelineStatus: sampleOverViewData,
  rulesAddedtoPipeline: [],
  rulePipelineStatusLoading: API_STATUS.IDLE,
  refreshStatus: API_STATUS.IDLE,
}

export const getRawDataAsync = createAsyncThunk(
  "dataQuality/getRawData",
  async () => {
    try {
      const axiosObj = new AxiosOperations()
      // return await axiosObj.get("data-quality-gen-ai/get-raw-data/")
      await new Promise((resolve) => setTimeout(resolve, 1000))
      return sampleRawData2
    } catch (error) {
      console.error("Error:", error)
      throw error
    }
  },
)

export const fetchDataQualityRulesAsync = createAsyncThunk(
  "dataQuality/getDataQualityRules",
  async ({ raw_data_name }: { raw_data_name: string }) => {
    try {
      const axiosObj = new AxiosOperations()
      const params = {
        raw_data_name: raw_data_name,
      }
      // return await axiosObj.post(
      //   "data-quality-gen-ai/data-quality-rules/",
      //   params,
      // )
      return sampleRules
    } catch (error) {
      console.error("Error:", error)
      throw error
    }
  },
)

export const getDataQualityImplementedRulesAsync = createAsyncThunk(
  "dataQuality/getImplementedRules",
  async ({ raw_data_name }: { raw_data_name: string }) => {
    try {
      const axiosObj = new AxiosOperations()
      const params = {
        raw_data_name: raw_data_name,
      }
      // return await axiosObj.get(
      //   `data-quality-gen-ai/data-quality-implemented-rules/`,
      //   params,
      // )
      await new Promise((resolve) => setTimeout(resolve, 1000))
      return sampleExistingRules
    } catch (error) {
      console.error("Error:", error)
      throw error
    }
  },
)

export const getDataQualityGenAiRulesAsync = createAsyncThunk(
  "dataQuality/getDataQualityGenAiRules",
  async ({ raw_data_name }: { raw_data_name: string }) => {
    try {
      const axiosObj = new AxiosOperations()
      const params = {
        raw_data_name: raw_data_name,
      }
      // return await axiosObj
      //   .post("data-quality-gen-ai/data-quality-gen-ai-rules/", params)
      //   .then((response) => response.Gen_AI_Rules)

      await new Promise((resolve) => setTimeout(resolve, 2000))

      return sampleGenAiRules
    } catch (error) {
      console.error("Error:", error)
      throw error
    }
  },
)

export const postDataQualityRulesAsync = createAsyncThunk(
  "dataQuality/postDataQualityGenAiRules",
  async (payload: any) => {
    try {
      const axiosObj = new AxiosOperations()
      return await axiosObj.post(
        "data-quality-gen-ai/sql-validation-as-per-selected-gen-ai-rules/",
        payload,
      )
    } catch (error) {
      console.error("Error:", error)
      throw error
    }
  },
)

export const getRulePipelineStatusAsync = createAsyncThunk(
  "dataQuality/getRulePipelineStatus",
  async (run_id: string) => {
    try {
      const axiosObj = new AxiosOperations()
      return await axiosObj.get(
        `data-quality-gen-ai/rule-pipeline-status/?run_id=${run_id}`,
      )
      return sampleRulePipelineStatus
    } catch (error) {
      console.error("Error:", error)
      throw error
    }
  },
)

export const pollRulePipelineStatusAsync = createAsyncThunk(
  "dataQuality/pollRulePipelineStatus",
  async (run_id: string, { dispatch }) => {
    const delay = (ms: number) =>
      new Promise((resolve) => setTimeout(resolve, ms))

    let response
    let error
    const pollCondition = true
    while (pollCondition) {
      try {
        response = await dispatch(getRulePipelineStatusAsync(run_id)).unwrap()
        if (response && response.data && response.data.length > 0) {
          console.log(response)
          return response
        }
      } catch (err) {
        error = err
      }
      await delay(20000)
    }
  },
)

const dataQualitySlice = createSlice({
  name: "dataQuality",
  initialState,
  reducers: {
    setActiveReportModal: (state, action: PayloadAction<boolean>) => {
      state.activeReportModal.status = action.payload
    },
    setDataQualityConfigModal: (state, action: PayloadAction<boolean>) => {
      state.dataQualityConfigModal = action.payload
    },
    setBusinessQualityConfigModal: (state, action: PayloadAction<boolean>) => {
      state.businessQualityConfigModal = action.payload
    },
    hitRefresh: (state) => {
      state.refreshHit += 1
    },
    addNavigationPath: (state, action: PayloadAction<string>) => {
      state.navigationHistory.push(action.payload)
    },
    removeNavigationPath: (state) => {
      state.navigationHistory.pop()
    },
    resetNavigationHistory: (state) => {
      state.navigationHistory = ["AI Enabled Quality"]
    },
    setActiveQualityTypeReport: (state, action: PayloadAction<any>) => {
      state.activeReportModal.qualityTypeId = action.payload
    },
    setSelectedDataset: (state, action: PayloadAction<string>) => {
      state.selectedDataSet = action.payload
    },
    setDataset: (state, action: PayloadAction<string>) => {
      state.aiRulesModalData.configuration.dataset = formatString(
        action.payload,
      )
      state.manualRulesModalData.dataset = formatString(action.payload)
    },
    setAiRulesModalData: (
      state,
      action: PayloadAction<{ columnsToApply: string; description: string }>,
    ) => {
      state.aiRulesModalData.configuration.columnsToApply =
        action.payload.columnsToApply
      state.aiRulesModalData.configuration.description =
        action.payload.description
    },
    resetAiRulesModalDataDescription: (
      state,
      action: PayloadAction<string>,
    ) => {
      state.aiRulesModalData.configuration.description = action.payload
    },
    selectGenAiRules: (
      state,
      action: PayloadAction<{ rule: IGenAiRules; qualityType: string }>,
    ) => {
      action.payload.qualityType === "data-quality"
        ? state.dataQualityRules.selectedAiGeneratedRules.push(
            action.payload.rule,
          )
        : state.businessQualityRules.selectedAiGeneratedRules.push(
            action.payload.rule,
          )
    },
    removeGenAiRule: (
      state,
      action: PayloadAction<{ ruleTitle: string; qualityType: string }>,
    ) => {
      action.payload.qualityType === "data-quality"
        ? (state.dataQualityRules.selectedAiGeneratedRules =
            state.dataQualityRules.selectedAiGeneratedRules.filter(
              (rule) => rule["Rule Title"] !== action.payload.ruleTitle,
            ))
        : (state.businessQualityRules.selectedAiGeneratedRules =
            state.businessQualityRules.selectedAiGeneratedRules.filter(
              (rule) => rule["Rule Title"] !== action.payload.ruleTitle,
            ))
    },
    selectExisitingRules: (
      state,
      action: PayloadAction<{ rule: IExistingRules; qualityType: string }>,
    ) => {
      console.log("added")
      action.payload.qualityType === "data-quality"
        ? state.dataQualityRules.selectedExistingRules.push(action.payload.rule)
        : state.businessQualityRules.selectedExistingRules.push(
            action.payload.rule,
          )
    },
    removeExistingRules: (
      state,
      action: PayloadAction<{ ruleTitle: string; qualityType: string }>,
    ) => {
      action.payload.qualityType === "data-quality"
        ? (state.dataQualityRules.selectedExistingRules =
            state.dataQualityRules.selectedExistingRules.filter(
              (rule) => rule.existing_rules !== action.payload.ruleTitle,
            ))
        : (state.businessQualityRules.selectedExistingRules =
            state.businessQualityRules.selectedExistingRules.filter(
              (rule) => rule.existing_rules !== action.payload.ruleTitle,
            ))
    },
    resetSelectedGenAiRules: (state) => {
      state.dataQualityRules.selectedAiGeneratedRules = []
    },
    addRuletoPipeline: (state) => {
      state.rulesAddedtoPipeline = state.rulesAddedtoPipeline.concat(
        state.rulePipelineStatus.filter((item) => {
          return item.RULE_TITLE === state.activeReportModal.qualityTypeId
        }),
      )
      state.activeReportModal.status = false
    },
    resetRulePipelineStatus: (state) => {
      state.rulePipelineStatus = []
    },
    resetRunId: (state) => {
      state.runId = null
    },
    setRulePipelineStatusLoading: (state, action: PayloadAction<string>) => {
      state.rulePipelineStatusLoading = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRawDataAsync.pending, (state) => {
        state.rawData.rawDataStatus = API_STATUS.LOADING
        state.refreshStatus = API_STATUS.LOADING
      })
      .addCase(getRawDataAsync.fulfilled, (state, action) => {
        state.rawData.rawDataStatus = API_STATUS.IDLE
        state.refreshStatus = API_STATUS.IDLE
        state.rawData.rawData = action.payload
      })
      .addCase(getRawDataAsync.rejected, (state) => {
        state.rawData.rawDataStatus = API_STATUS.FAILED
        state.refreshStatus = API_STATUS.FAILED
        state.rawData.error = "Something went wrong"
      })

      .addCase(getDataQualityImplementedRulesAsync.pending, (state) => {
        state.dataQualityRules.ImplementedRulesStatus = API_STATUS.LOADING
        state.refreshStatus = API_STATUS.LOADING
      })
      .addCase(
        getDataQualityImplementedRulesAsync.fulfilled,
        (state, action: PayloadAction<IExistingRules[]>) => {
          state.dataQualityRules.ImplementedRulesStatus = API_STATUS.IDLE
          state.refreshStatus = API_STATUS.IDLE
          state.dataQualityRules.existingRules = action.payload

          // add existing rules to selected existing rules
          state.dataQualityRules.selectedExistingRules = action.payload
        },
      )
      .addCase(getDataQualityImplementedRulesAsync.rejected, (state) => {
        state.dataQualityRules.ImplementedRulesStatus = API_STATUS.FAILED
        state.refreshStatus = API_STATUS.FAILED
      })

      .addCase(getDataQualityGenAiRulesAsync.pending, (state) => {
        state.dataQualityRules.GenAiRulesStatus = API_STATUS.LOADING
        state.refreshStatus = API_STATUS.LOADING
      })
      .addCase(
        getDataQualityGenAiRulesAsync.fulfilled,
        (state, action: PayloadAction<IGenAiRules[]>) => {
          state.dataQualityRules.GenAiRulesStatus = API_STATUS.IDLE
          state.refreshStatus = API_STATUS.IDLE
          state.dataQualityRules.genAiRules = action.payload
        },
      )
      .addCase(getDataQualityGenAiRulesAsync.rejected, (state) => {
        state.dataQualityRules.GenAiRulesStatus = API_STATUS.FAILED
        state.refreshStatus = API_STATUS.FAILED
      })

      .addCase(postDataQualityRulesAsync.pending, (state) => {
        state.runQCCheck = API_STATUS.LOADING
      })
      .addCase(postDataQualityRulesAsync.fulfilled, (state, action) => {
        state.runQCCheck = API_STATUS.IDLE
        state.runId = action.payload.run_id
        console.log(action.payload.run_id)
      })
      .addCase(postDataQualityRulesAsync.rejected, (state) => {
        state.runQCCheck = API_STATUS.FAILED
        state.runId = null
      })

      .addCase(pollRulePipelineStatusAsync.pending, (state) => {
        state.rulePipelineStatusLoading = API_STATUS.LOADING
        state.refreshStatus = API_STATUS.LOADING
      })
      .addCase(pollRulePipelineStatusAsync.fulfilled, (state, action) => {
        state.rulePipelineStatus = action.payload.data
        state.refreshStatus = API_STATUS.IDLE

        const recData = action.payload.data

        recData.forEach((item: any) => {
          if (item.RESULT) {
            item.RESULT = JSON.parse(
              item.RESULT.replace(/'/g, '"').replace(
                /Decimal\("(.*?)"\)/g,
                "$1",
              ),
            )
          }

          if (item.RESULT && Array.isArray(item.RESULT)) {
            const keys = Object.keys(item.RESULT[0])
            const formattedResult: Record<string, any[]> = {}
            keys.forEach((key) => {
              formattedResult[key] = item.RESULT.map(
                (entry: { [x: string]: any }) => entry[key],
              )
            })

            item.RESULT = formattedResult
          }
        })

        console.log(recData)
        state.rulePipelineStatus = recData

        state.rulePipelineStatusLoading = API_STATUS.IDLE
      })
      .addCase(pollRulePipelineStatusAsync.rejected, (state) => {
        state.rulePipelineStatusLoading = API_STATUS.FAILED
        state.refreshStatus = API_STATUS.FAILED
      })
  },
})

export const {
  setActiveReportModal,
  hitRefresh,
  addNavigationPath,
  removeNavigationPath,
  setDataQualityConfigModal,
  setBusinessQualityConfigModal,
  resetNavigationHistory,
  setSelectedDataset,
  setActiveQualityTypeReport,
  setDataset,
  setAiRulesModalData,
  resetAiRulesModalDataDescription,
  selectGenAiRules,
  removeGenAiRule,
  resetSelectedGenAiRules,
  selectExisitingRules,
  removeExistingRules,
  addRuletoPipeline,
  resetRulePipelineStatus,
  resetRunId,
  setRulePipelineStatusLoading,
} = dataQualitySlice.actions

export default dataQualitySlice.reducer

const formatString = (inputStr: string): string => {
  return inputStr
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
}
